export const statusConfig = {
  processing: {
    label: "Ожидает",
    className: "bg-gray-500 hover:bg-gray-600 text-white",
  },
  paid: {
    label: "Оплачен",
    className: "bg-green-500 hover:bg-green-600 text-white",
  },
  created: {
    label: "Cоздан",
    className: "bg-blue-500 hover:bg-blue-600 text-white",
  },
  cancelled: {
    label: "Отменён",
    className: "bg-red-500 hover:bg-red-600 text-white",
  },
  failed: {
    label: "Ошибка оплаты",
    className: "bg-red-500 hover:bg-red-600 text-white",
  },
  unknown: {
    label: "Неизвестен",
    className: "bg-gray-400 hover:bg-gray-500 text-black",
  },
} as const;

type StatusKey = keyof typeof statusConfig;

export const getStatusConfig = (status: string) =>
  statusConfig[status as StatusKey] ?? statusConfig.unknown;

export const paymentStatusLabels = {
  paid: "Оплачен",
  not_paid: "Не оплачен",
  processing: "Ожидает оплаты",
  cancelled: "Отменен",
  failed: "Ошибка оплаты",
};
